export enum RecipientType {
    None, // used for compact truncated recipient well
    To,
    Cc,
    Bcc,
}
